import { render, staticRenderFns } from "./MarketStartupsModal.vue?vue&type=template&id=6f44e8fb&scoped=true&"
import script from "./MarketStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarketStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44e8fb",
  null
  
)

export default component.exports